export default __webpack_public_path__ + "static/media/TreasureHunting_12.b5381e40.png";